import { RfxLead } from "newui/features/Rfx/types/rfx.types";
import { FiAlertCircle } from "react-icons/fi";
import { RfxLeadInfoBox } from "../steps/InitialEvaluationStep/panel";

interface ConflictPendingReviewNoticeProps {
	hideLeadInfo?: boolean;
	rfxLead: RfxLead | undefined | null;
}

/**
 * Canonical "scoring blocked — conflict of interest awaiting review" notice.
 * Shown identically wherever a panel member who declared a conflict is held
 * until the RFx Lead reviews it (the evaluation page, the evaluation tab, and
 * immediately after the member submits their declaration).
 */
export const ConflictPendingReviewNotice = ({ hideLeadInfo = false, rfxLead }: ConflictPendingReviewNoticeProps) => {
	return (
		<div className="space-y-4" data-testid="panel-member-scoring-blocked">
			<div className="flex items-start gap-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3">
				<FiAlertCircle size={18} className="mt-0.5 shrink-0 text-amber-600" aria-hidden="true" />
				<div>
					<p className="text-sm font-medium text-amber-900">
						Access to scoring is restricted
					</p>
					<p className="mt-0.5 text-sm text-amber-800">
						You have declared a conflict of interest. The RFx Lead must review
						and approve it before you can proceed to scoring. You will be
						notified once it has been reviewed.
					</p>
				</div>
			</div>

			{!hideLeadInfo && rfxLead && <RfxLeadInfoBox rfxLead={rfxLead} />}
		</div>
	);
};
